import { IChuongTrinhDaoTaoRangBuocActionTypes } from "../../action-types/ctdt/IChuongTrinhDaoTaoRangBuocActions";
import { IChuongTrinhDaoTaoRangBuocReducer } from "../../reducer-model/ctdt/IChuongTrinhDaoTaoRangBuocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IChuongTrinhDaoTaoRangBuocReducer = {
    status: eReducerStatusBase.is_not_initialization,
    chuongTrinhDaoTaoRangBuocs: [],
}

export const chuongTrinhDaoTaoRangBuocReducer = (
    state: IChuongTrinhDaoTaoRangBuocReducer = iniState,
    action: IChuongTrinhDaoTaoRangBuocActionTypes
): IChuongTrinhDaoTaoRangBuocReducer => {
    switch (action.type) {
        case "CHUONG_TRINH_DAO_TAO_RANG_BUOC_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case "CHUONG_TRINH_DAO_TAO_RANG_BUOC_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                chuongTrinhDaoTaoRangBuocs: action.payload,
            }
        case "CHUONG_TRINH_DAO_TAO_RANG_BUOC_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case "CHUONG_TRINH_DAO_TAO_RANG_BUOC_SAVE_MULTIPLE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            }
        case "CHUONG_TRINH_DAO_TAO_RANG_BUOC_SAVE_MULTIPLE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "CHUONG_TRINH_DAO_TAO_RANG_BUOC_SAVE_MULTIPLE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        default:
            return state;
    }
}